import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  LanguageCodeEnum,
  ShippingMethodTranslationInput
} from "../../types/globalTypes";
import TranslationsShippingMethodPage, {
  fieldNames
} from "../components/TranslationsShippingMethodPage";
import { TypedUpdateShippingMethodTranslations } from "../mutations";
import { TypedShippingMethodTranslationDetails } from "../queries";
import { UpdateShippingMethodTranslations } from "../types/UpdateShippingMethodTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsShippingMethodQueryParams {
  activeField: string;
}
export interface TranslationsShippingMethodProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsShippingMethodQueryParams;
}

const TranslationsShippingMethod: React.FC<TranslationsShippingMethodProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateShippingMethodTranslations) => {
    if (data.shippingMethodTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedShippingMethodTranslationDetails
      variables={{ id, language: languageCode }}
    >
      {pageHeaderTranslations => (
        <TypedUpdateShippingMethodTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: ShippingMethodTranslationInput = {};
              if (field === fieldNames.name) {
                input.name = data;
              } else if (field === fieldNames.instructions) {
                input.instructions = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsShippingMethodPage
                activeField={params.activeField}
                disabled={
                  pageHeaderTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(
                      lang,
                      TranslatableEntities.shippingMethod,
                      id
                    )
                  )
                }
                onSubmit={handleSubmit}
                shippingMethod={maybe(
                  () => pageHeaderTranslations.data.shippingMethod
                )}
              />
            );
          }}
        </TypedUpdateShippingMethodTranslations>
      )}
    </TypedShippingMethodTranslationDetails>
  );
};
TranslationsShippingMethod.displayName = "TranslationsShippingMethod";
export default TranslationsShippingMethod;
